import styled from 'styled-components';
import { MAT_ASPECT } from '../Board/layout';
import { Count } from '../Card/styled';

/** Games as tiles: as many across as fit, at least two on a phone. */
export const GameGrid = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));

  @media (min-width: 900px) {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  }
  gap: 10px;
`;

export const GameTile = styled.li`
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  overflow: hidden;
  background: var(--felt-deep);
  outline: ${props => (props.$picked && '3px solid var(--ink)') || (props.$yourMove && '2px solid var(--accent)') || 'none'};
  /* Nothing for you to do there (their move, or finished). Its count of new moves stays bright. */
  & > a > :not([data-new-moves]), & > div {
    opacity: ${props => props.$idle ? 0.5 : 1};
    filter: ${props => props.$idle ? 'grayscale(.8)' : 'none'};
  }

  & > a {
    position: relative;
    display: flex;
    flex-direction: column;
    color: var(--ink);
    text-decoration: none;
  }
`;

export const TileText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 10px 4px;
  font-size: 14px;
`;

export const TileFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px 8px;
  font-size: 12px;
  color: var(--muted);

  & button {
    min-height: 0;
    padding: 4px 10px;
    font-size: 12px;
  }
`;

export const Status = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${props => props.$yourMove ? 'var(--accent)' : 'var(--muted)'};
`;

/** Over the list: how it's sorted, and picking games to act on together. */
export const ListBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-size: 14px;

  & > label {
    margin-right: auto;
  }
`;

export const SortBar = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--muted);
`;

/** The tick on a game while picking games: filled once it's picked. */
export const Check = styled.span`
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 1;
  width: 26px;
  height: 26px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  border: 2px solid #fff;
  background: ${props => (props.$on ? 'var(--accent)' : 'rgba(0, 0, 0, .45)')};
  color: var(--accent-ink);
  font-weight: 800;
`;

/**
 * The frame for a game's picture: the mat's own shape, and a size container so the mat inside sizes itself from it
 * the same way the game's board does from the screen.
 */
export const MiniFrame = styled.div`
  aspect-ratio: ${MAT_ASPECT};
  container-type: size;
  display: flex;

  /* Count badges have a smallest size for the board; on these little cards that would cover them. */
  ${Count} {
    transform: scale(.55);
    transform-origin: top right;
  }
`;

/** How many of the other player's moves you haven't seen, over the corner of the game's picture. */
export const NewMoves = styled.span`
  position: absolute;
  top: 6px;
  right: 6px;
  padding: 2px 8px;
  border-radius: 999px;
  background: var(--accent);
  color: var(--felt-deep);
  font-size: 12px;
  font-weight: 700;
  box-shadow: 0 2px 6px rgba(0, 0, 0, .4);
`;
